import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Horse Riding Instructor — London, UK',
  text: '"I no longer spend my Sunday evenings building lesson plans from scratch. I open the system, pick the lesson, and walk into the arena completely prepared. My students feel the difference — and so do I."'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Riding Instructor — Toronto, Canada',
  text: '"The Corrections and Adaptations Manual alone saved me more times than I can count in my first month. That manual is worth the full price by itself."'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Horse Riding Instructor — Sydney, Australia',
  text: '"The Mixed-Level Adaptation System completely changed how I teach. My progressions are smoother, my language is clearer, and my students stay focused from the very first exercise to the final cool-down."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream border-y border-gold-aged/30" data-id="element-307" data-mp="cek293sh6pgb">
      <div className="max-w-7xl mx-auto px-4" data-id="element-308" data-mp="gfcd21gzx2ep">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-309" data-mp="gby94osool55">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white border border-gold/40 p-6 rounded-2xl relative shadow-[0_4px_16px_rgba(18,53,36,0.06)]" data-id="element-310" data-mp="lbkn50gc65f0" data-mpi={i}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-311" data-mp="144et54vzen73">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-312" data-mp="35wbet7bv5dfl" data-mpi={j} />)}
              </div>
              <p className="text-ink italic mb-6 text-sm leading-relaxed" data-id="element-313" data-mp="3avec25llqfd0">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-314" data-mp="i0eb04q50ab9">
                <div className="w-10 h-10 rounded-full bg-forest border border-gold flex items-center justify-center text-ivory font-bold" data-id="element-315" data-mp="d1b56i2c2028">
                  {t.initials}
                </div>
                <div data-id="element-316" data-mp="m0yahey6nq0k">
                  <div className="font-bold text-forest text-sm" data-id="element-317" data-mp="m0eptqh5eniu">{t.name}</div>
                  <div className="text-xs text-warmgray" data-id="element-318" data-mp="10y73se71r3ux">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}